import React from 'react';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'The online booking steps made it easy to choose the right size for our cleanout.',
  label: 'Representative feedback · Homeowner, local cleanout'
}, {
  quote: 'Clear pricing and a simple delivery window helped keep our renovation moving.',
  label: 'Representative feedback · Renovation customer'
}, {
  quote: 'A straightforward option when you need a dumpster without the runaround.',
  label: 'Representative feedback · Local contractor'
}];
export function Testimonials() {
  return <section className="w-full border-y border-border bg-secondary/40 py-16 md:py-20" aria-labelledby="testimonials-heading" data-id="element-342">
      <div className="container" data-id="element-343">
        <div className="flex flex-col items-center justify-between gap-3 text-center md:flex-row md:text-left" data-id="element-344">
          <div data-id="element-345">
            <p className="text-sm font-medium text-primary" data-id="element-346">
              Built for straightforward projects
            </p>
            <h2 id="testimonials-heading" className="mt-1 text-2xl font-semibold tracking-tight text-foreground" data-id="element-347">
              What customers value most
            </h2>
          </div>
          <p className="max-w-sm text-sm text-muted-foreground" data-id="element-348">
            Representative feedback shown for this homepage prototype.
          </p>
        </div>
        <div className="mt-8 grid gap-5 md:grid-cols-3" data-id="element-349">
          {testimonials.map(item => <figure key={item.label} className="rounded-xl border border-border bg-card p-6" data-id="element-350">
              <Quote className="h-5 w-5 text-primary" data-id="element-351" />
              <blockquote className="mt-4 text-sm leading-6 text-card-foreground" data-id="element-352">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 text-xs text-muted-foreground" data-id="element-353">
                {item.label}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}